import { render, staticRenderFns } from "./LinksFormLogin.vue?vue&type=template&id=064fd79e&scoped=true"
import script from "./LinksFormLogin.vue?vue&type=script&lang=js"
export * from "./LinksFormLogin.vue?vue&type=script&lang=js"
import style0 from "./LinksFormLogin.vue?vue&type=style&index=0&id=064fd79e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fd79e",
  null
  
)

export default component.exports